import { render, staticRenderFns } from "./invoiceAddTips.vue?vue&type=template&id=5c97abba&"
import script from "./invoiceAddTips.vue?vue&type=script&lang=js&"
export * from "./invoiceAddTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports